import { create } from 'zustand'

import {
  bulkDistributeBilling,
  getClients,
  getClientsByFilter,
  getOtherServices,
  createNewOtherService,
  editOtherService,
  removeOtherService,
  getWeeklybreakdown,
  getDetailedSummary,
  editDetailedSummary,
  getPreviewDetails,
  approvalWorkflow,
  reversePreviewInvoicing,
  releasePreviewInvoicing,
  restorePreviewInvoicing
} from './provider'

import type { UseInvoicingProps } from './types'
import type { GetClientsRequestProps } from '@services/api/invoicing/types'

export const useInvoicing = create<UseInvoicingProps>((set) => ({
  clientsData: null,
  setClientsData: (value) => set({ clientsData: value }),

  isClientsLoading: false,
  setIsClientsLoading: (value) => set({ isClientsLoading: value }),

  isClientsByFilterLoading: false,
  setIsClientsByFilterLoading: (value) => set({ isClientsByFilterLoading: value }),

  otherServicesData: null,
  setOtherServicesData: (value) => set({ otherServicesData: value }),

  isOtherServicesLoading: false,
  setIsOtherServicesLoading: (value) => set({ isOtherServicesLoading: value }),

  isCreateNewOtherServiceLoading: false,
  setIsCreateNewOtherServiceLoading: (value) => set({ isCreateNewOtherServiceLoading: value }),

  isRemoveOtherServiceLoading: false,
  setIsRemoveOtherServiceLoading: (value) => set({ isRemoveOtherServiceLoading: value }),

  weeklybreakdownData: null,
  setWeeklybreakdownData: (value) => set({ weeklybreakdownData: value }),

  isWeeklybreakdownLoading: false,
  setIsWeeklybreakdownLoading: (value) => set({ isWeeklybreakdownLoading: value }),

  detailedSummaryData: null,
  setDetailedSummaryData: (value) => set({ detailedSummaryData: value }),

  isDetailedSummaryLoading: false,
  setIsDetailedSummaryLoading: (value) => set({ isDetailedSummaryLoading: value }),

  isEditDetailedSummaryLoading: false,
  setIsEditDetailedSummaryLoading: (value) => set({ isEditDetailedSummaryLoading: value }),

  previewDetailsData: null,
  setPreviewDetailsData: (value) => set({ previewDetailsData: value }),

  isPreviewDetailsLoading: false,
  setIsPreviewDetailsLoading: (value) => set({ isPreviewDetailsLoading: value }),

  isApprovalWorkflowLoading: false,
  setIsApprovalWorkflowLoading: (value) => set({ isApprovalWorkflowLoading: value }),

  isReversePreviewInvoicingLoading: false,
  setIsReversePreviewInvoicingLoading: (value) => set({ isReversePreviewInvoicingLoading: value }),

  isReleasePreviewInvoicingLoading: false,
  setIsReleasePreviewInvoicingLoading: (value) => set({ isReleasePreviewInvoicingLoading: value }),

  isRestorePreviewInvoicingLoading: false,
  setIsRestorePreviewInvoicingLoading: (value) => set({ isRestorePreviewInvoicingLoading: value }),

  isBulkDistributeBillingLoading: false,
  setIsBulkDistributeBillingLoading: (value) => set({ isBulkDistributeBillingLoading: value }),

  getClients,
  getClientsByFilter: getClientsByFilter as (payload: GetClientsRequestProps, searchText?: string) => Promise<void>,
  getOtherServices,
  createNewOtherService,
  editOtherService,
  removeOtherService,
  getWeeklybreakdown,
  getDetailedSummary,
  editDetailedSummary,
  getPreviewDetails,
  approvalWorkflow,
  reversePreviewInvoicing,
  releasePreviewInvoicing,
  restorePreviewInvoicing,
  bulkDistributeBilling
}))
